import React from 'react';
import { BuildingIcon, CheckSquareIcon, AlertTriangleIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
const projects = [{
  name: '3GP',
  location: 'Tengiz / Теңгіз / Тенгиз'
}, {
  name: '3GI',
  location: 'Tengiz / Теңгіз / Тенгиз'
}, {
  name: 'CNPC-AMG',
  location: 'Aktobe / Ақтөбе / Актобе'
}, {
  name: 'KAZ Minerals',
  location: 'Aktogay / Ақтоғай / Актогай'
}, {
  name: 'GPC',
  location: 'Aktobe / Ақтөбе / Актобе'
}];
const scopeKeys = ['experience.scope.item1', 'experience.scope.item2', 'experience.scope.item3', 'experience.scope.item4', 'experience.scope.item5'];
export function Experience() {
  const {
    t
  } = useLanguage();
  return <section id="experience" className="w-full bg-graphite py-20 sm:py-28" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <ScrollFadeIn data-id="element-130">
          <div className="mb-4" data-id="element-131">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-electric" data-id="element-132">
              {t('experience.label')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mb-6" data-id="element-133">
            {t('experience.heading')}
          </h2>
        </ScrollFadeIn>

        <ScrollFadeIn delay={100} data-id="element-134">
          <div className="flex items-start gap-3 p-4 bg-navy/60 border border-slate-700/40 rounded mb-8" data-id="element-135">
            <AlertTriangleIcon className="w-5 h-5 text-electric shrink-0 mt-0.5" data-id="element-136" />
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-137">
              {t('experience.disclaimer')}
            </p>
          </div>
        </ScrollFadeIn>

        {/* Project References */}
        <ScrollFadeIn delay={200} data-id="element-138">
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3 mb-8" data-id="element-139">
            {projects.map(project => <div key={project.name} className="p-4 bg-navy border border-slate-700/50 rounded text-center" data-id="element-140">
                <BuildingIcon className="w-5 h-5 text-electric mx-auto mb-2" data-id="element-141" />
                <div className="text-sm font-bold text-white tracking-wide" data-id="element-142">
                  {project.name}
                </div>
                <div className="text-[10px] text-slate-500 uppercase tracking-wider mt-1" data-id="element-143">
                  {project.location}
                </div>
              </div>)}
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn delay={250} data-id="element-144">
          <p className="text-xs text-slate-500 italic mb-10" data-id="element-145">
            {t('experience.note')}
          </p>
        </ScrollFadeIn>

        {/* Scope of Work */}
        <ScrollFadeIn delay={300} data-id="element-146">
          <div className="p-6 bg-navy border border-slate-700/50 rounded" data-id="element-147">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4" data-id="element-148">
              {t('experience.scope.title')}
            </h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-149">
              {scopeKeys.map(key => <div key={key} className="flex items-center gap-2.5" data-id="element-150">
                  <CheckSquareIcon className="w-4 h-4 text-electric shrink-0" data-id="element-151" />
                  <span className="text-sm text-slate-400" data-id="element-152">{t(key)}</span>
                </div>)}
            </div>
          </div>
        </ScrollFadeIn>
      </div>
    </section>;
}